export default __webpack_public_path__ + "static/media/dig.153d10d4.jpg";